import { FC, useCallback } from 'react';
import { useFragment, useMutation } from 'react-relay';
import { Formik } from 'formik';
import graphql from 'babel-plugin-relay/macro';

import Stack from '@mui/material/Stack';
import Form from 'components/Form';
import AccordionController from 'components/AccordionController';
import Section from 'components/Section';
import TextField from 'components/TextField';

import { useErrorHandler } from 'lib';
import { ServiceGroupEditMain_serviceGroup$key } from '__generated__/ServiceGroupEditMain_serviceGroup.graphql';

type FormValues = {
  name: string;
};

type Props = {
  serviceGroup: ServiceGroupEditMain_serviceGroup$key;
};

const ServiceGroupEditMain: FC<Props> = props => {
  const errorHandler = useErrorHandler();

  const { id, ...initial } = useFragment(
    graphql`
      fragment ServiceGroupEditMain_serviceGroup on ServiceGroup {
        id
        name
      }
    `,
    props.serviceGroup
  );

  const [update, updating] = useMutation(graphql`
    mutation ServiceGroupEditMainMutation(
      $id: ID!
      $input: UpdateServiceGroupInput! # $first: Int # $after: String # $search: String
    ) {
      updateServiceGroup(id: $id, input: $input) {
        ...ServiceGroupEditTabs_serviceGroup
        ...EntitySidebar_entity
      }
    }
  `);

  const handleSubmit = useCallback(
    (input: FormValues) => {
      update({
        variables: { id, input },

        ...errorHandler({
          successMessage: 'Išsaugota',
        }),
      });
    },
    [errorHandler, id, update]
  );

  return (
    <Formik<FormValues> initialValues={initial} onSubmit={handleSubmit}>
      <Form loading={updating}>
        <AccordionController id="serviceGroupMain">
          <Section title="Apie" id="general">
            <Stack spacing={4}>
              <TextField name="name" label="Pavadinimas" />
            </Stack>
          </Section>
        </AccordionController>
      </Form>
    </Formik>
  );
};

export default ServiceGroupEditMain;
